import styled from 'styled-components'

export const MusicPracticeFormStyled = styled.div`
  .time_rec_label {
    margin-top: 6px;
    color: ${({ theme }) => theme.COLORS.GRAY_2};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
  }
`
